<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>工序跟踪</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
          <el-row :gutter="20">
            <el-col :span="3">
              <el-tooltip class="item" effect="light" content="订单编号" placement="top">
                <el-input v-model="queryInfo.orderNo" placeholder="订单编号" size="mini" style="width: 85%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="请选择订单状态" placement="top">
                <el-select v-model="queryInfo.processCode" placeholder="请选择工序代码" size="mini">
                  <el-option label="所有工序" value="所有工序"></el-option>
                  <el-option label="工序一" value="工序一"></el-option>
                  <el-option label="工序二" value="工序一"></el-option>
                  <el-option label="工序三" value="工序一"></el-option>
                  <el-option label="工序四" value="工序一"></el-option>
                  <el-option label="工序五" value="工序一"></el-option>
                  <el-option label="工序六" value="工序一"></el-option>
                  <el-option label="工序七" value="工序一"></el-option>
                  <el-option label="工序八" value="工序一"></el-option>
                  <el-option label="工序九" value="工序一"></el-option>
                  <el-option label="工序十" value="工序一"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="5" style="margin-left: -0.3%;">
              <el-tooltip class="item" effect="light" content="更新时间" placement="top">
                <el-date-picker
                  v-model="queryInfo.updateTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="更新"
                  end-placeholder="时间"
                  size="mini"
                  style="width: 100%;">
                </el-date-picker>
              </el-tooltip>
            </el-col>
            <el-col :span="3" style="margin-left: -0.3%;">
              <el-tooltip class="item" effect="light" content="操作员" placement="top">
                <el-input v-model="queryInfo.opPerson" placeholder="操作人员" size="mini" style="width: 70%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="1" style="margin-left: -3.5%;">
              <el-tooltip class="item" effect="light" content="搜索或保留条件刷新,可在页面中使用回车键代替" placement="top">
                <el-button icon="el-icon-search" circle size="mini" @click="search()"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -1%;">
              <el-button type="primary" round size="mini" @click="unfinishedOrder()">未完成订单</el-button>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-button type="info" round size="mini" @click="exportExcel()">导出Excel</el-button>
            </el-col>
          </el-row>
          
          <el-table max-height="630" :data="orderTailList" border style="width: 100%" size="mini"
            ref="multipleTable" tooltip-effect="dark" :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="37"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="orderNo" label="订单编号" width="180%"></el-table-column>
            <el-table-column prop="updateTime" label="跟踪时间" width="150%"></el-table-column>
            <el-table-column prop="tailStatus" label="跟踪状态" width="200%"></el-table-column>
            <el-table-column prop="processType" label="工序类型"></el-table-column>
            <el-table-column prop="inputPerson" label="录入员工"></el-table-column>
            <el-table-column prop="orderStatus" label="订单状态" width="80%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="orderDateTime" label="接单时间" width="150%"></el-table-column>
            <el-table-column prop="productName" label="产品名称" width="190%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="speModel" label="规格型号" width="130%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="colour" label="颜色" width="150%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="sheetMaterial" label="板材材料" width="128%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="quantity" label="数量"></el-table-column>
            <el-table-column prop="cabinetArea" label="柜体面积"></el-table-column>
            <el-table-column prop="outsideProductCost" label="外采费用"></el-table-column>
            <el-table-column prop="doorPlankArea" label="门板面积"></el-table-column>
            <el-table-column prop="totalMoney" label="订单金额"></el-table-column>
            <el-table-column prop="shop" label="订货店铺"></el-table-column>
            <el-table-column prop="customerId" label="客户ID" width="100%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="customerName" label="客户姓名" width="90%" show-overflow-tooltip=false></el-table-column>
            
            <el-table-column
              fixed="right"
              label="操作"
              width="200%">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="processCount(scope.$index, scope.row)">工序统计</el-button>
                <el-button type="info" size="mini" @click="tailCount(scope.$index, scope.row)">跟踪统计</el-button>
              </template>
            </el-table-column>
            
          </el-table>
    
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[10,20,50,100,200,500]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
        
        <dev>
          <!-- 工序统计模态窗口 -->
          <el-dialog title="工序统计" :visible.sync="processCountDialogVisible">
            <el-table max-height="630" :data="processInfoList" style="width: 100%; margin-top: -3%;">
              <el-table-column prop="updateTime" label="工序时间"></el-table-column>
              <el-table-column prop="processType" label="工序类型"></el-table-column>
              <el-table-column prop="content" label="工序内容"></el-table-column>
            </el-table>
          </el-dialog>
          
          <!-- 跟踪统计模态窗口 -->
          <el-dialog title="跟踪统计" :visible.sync="tailCountDialogVisible">
            <el-table max-height="630" :data="tailInfoList" style="width: 100%; margin-top: -3%;">
              <el-table-column prop="updateTime" label="跟踪时间" width="150%"></el-table-column>
              <el-table-column prop="content" label="跟踪状态" width="200%"></el-table-column>
            </el-table>
          </el-dialog>
        </dev>
        
      </div>
    </template>
    
<script>
  export default {
    data() {
      return {
        queryInfo: {
          orderNo: "",
          scopeDateTime: "",
          orderStatus: "",
          shop: "",
          customerId: "",
          customerPhone: "",
          pageNum: 1,
          pageSize: 10
        },
        orderTailList: [
          {
            orderNo: "订单编号",
            updateTime: "跟踪时间",
            tailStatus: "跟踪状态",
            processType: "工序类型",
            inputPerson: "录入员工",
            orderStatus: "订单状态",
            orderDateTime: "接单时间",
            productName: "产品名称",
            speModel: "规格型号",
            colour: "颜色",
            quantity: "数量",
            cabinetArea: "柜体面积",
            outsideProductCost: "外采费用",
            doorPlankArea: "门板面积",
            totalMoney: "订单金额",
            shop: "订货店铺",
            customerId: "客户ID",
            customerName: "客户姓名"
          },
          {
            orderNo: "订单编号",
            updateTime: "跟踪时间",
            tailStatus: "跟踪状态",
            processType: "工序类型",
            inputPerson: "录入员工",
            orderStatus: "订单状态",
            orderDateTime: "接单时间",
            productName: "产品名称",
            speModel: "规格型号",
            colour: "颜色",
            quantity: "数量",
            cabinetArea: "柜体面积",
            outsideProductCost: "外采费用",
            doorPlankArea: "门板面积",
            totalMoney: "订单金额",
            shop: "订货店铺",
            customerId: "客户ID",
            customerName: "客户姓名"
          },
          {
            orderNo: "订单编号",
            updateTime: "跟踪时间",
            tailStatus: "跟踪状态",
            processType: "工序类型",
            inputPerson: "录入员工",
            orderStatus: "订单状态",
            orderDateTime: "接单时间",
            productName: "产品名称",
            speModel: "规格型号",
            colour: "颜色",
            quantity: "数量",
            cabinetArea: "柜体面积",
            outsideProductCost: "外采费用",
            doorPlankArea: "门板面积",
            totalMoney: "订单金额",
            shop: "订货店铺",
            customerId: "客户ID",
            customerName: "客户姓名"
          }
        ],
        total: 3,
        
        processCountDialogVisible: false,
        processInfoList: [],
        
        tailCountDialogVisible: false,
        tailInfoList: []
      };
    },
    methods: {
      async getOrderTailList() {
        const { data } = await this.$http.get("orders", {
          params: this.queryInfo
        });
        if (data.meta.status !== 200) {
          return this.$message.error(data.meta.msg);
        }
        this.orderTailList = data.data.orderTailList;
        this.total = data.data.total;
      },
      handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        this.getOrderList();
      },
      handleCurrentChange(newPage) {
        this.queryInfo.pageNum = newPage;
        this.getOrderList();
      },
      // 选择
      handleSelectionChange(val) {
        this.multipleSelection = val;
        //console.log(val);
      },
      // 加急标红
      tableRowClassName({row, rowIndex}) {
        if (row.orderType == "加急订单") {
          return 'warning-row';
        }
        return '';
      },
      //搜索
      search(){
        //console.log(this.queryInfo);
        
        this.$message({
          type: 'success',
          message: '搜索!'
        });
      },
      //未完成订单
      unfinishedOrder(){
        this.$message({
          type: 'success',
          message: '未完成订单!'
        });
      },
      //导出Excel
      exportExcel(){
        this.$message({
          type: 'success',
          message: '导出Excel!'
        });
      },
      //工序统计
      processCount(index, orderInfo){
        this.processInfoList = [
          {
            orderNo: "1",
            updateTime: "2020-01-03 13:23:23",
            processType: "工序三",
            content: "工序三"
          },
          {
            orderNo: "1",
            updateTime: "2020-01-02 13:23:23",
            processType: "工序二",
            content: "工序二"
          },
          {
            orderNo: "1",
            updateTime: "2020-01-01 13:23:23",
            processType: "工序一",
            content: "工序一"
          }
        ];
        
        this.processCountDialogVisible = true;
      },
      //跟踪统计
      tailCount(index, orderInfo){
        this.tailInfoList = [
          {
            orderNo: "1",
            updateTime: "2020-01-03 13:23:23",
            content: "跟踪状态三"
          },
          {
            orderNo: "1",
            updateTime: "2020-01-02 13:23:23",
            content: "跟踪状态二"
          },
          {
            orderNo: "1",
            updateTime: "2020-01-01 13:23:23",
            content: "跟踪状态一"
          }
        ]
        
        this.tailCountDialogVisible = true;
      }
      
    }
  };
</script>

<style>
.el-cascader {
  width: 100%;
}
.el-table .warning-row {
  color: #ff0000;
}
</style>
